import { useTranslation } from "react-i18next";

import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import { ShellBreadcrumb } from "@/components/shell-breadcrumb";
import { ShellHeaderActions } from "@/components/shell-header-actions";
import { MerchantSidebar } from "./merchant-sidebar";

export function MerchantShell({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-surface">
        <MerchantSidebar />
        <SidebarInset className="min-w-0 overflow-x-hidden bg-surface">
          <header className="sticky top-0 z-20 flex items-center gap-4 border-b border-border/60 bg-background/80 px-4 py-3 backdrop-blur sm:px-6">
            <SidebarTrigger className="-ms-1" />
            <ShellBreadcrumb root="merchant" />
            {/* <div className="relative hidden flex-1 max-w-md md:block">
              <Search className="pointer-events-none absolute start-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <Input
                placeholder="Search bookings, spaces, customers…"
                className="h-10 rounded-xl border-border/70 bg-surface ps-10"
              />  */}

            <ShellHeaderActions initials="AM" />
          </header>

          <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
            <div className="mx-auto w-full max-w-7xl">
              <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
                <div>
                  <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
                  {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
                </div>
                {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
              </div>
              {children}
            </div>
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
